import React from 'react';
import styled from 'styled-components';
import { formatPrice } from '@lemonadefashion/money';
import { useTokenTranslate } from '../../contexts/token_translation_context';

const toArabicNumerals = (n) =>
  String(n).replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);

const getTimeDifference = (dateString, now = new Date(), isArabic = false) => {
  const diff = now - new Date(dateString);
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);
  const years = Math.floor(days / 365);
  if (isArabic) {
    if (diff < 0 || seconds < 60) return 'الآن';
    if (minutes < 60) return `${toArabicNumerals(minutes)}د`;
    if (hours < 24) return `${toArabicNumerals(hours)}س`;
    if (days < 7) return `${toArabicNumerals(days)}ي`;
    if (weeks < 52) return `${toArabicNumerals(weeks)}أ`;
    return `${toArabicNumerals(years)}ع`;
  }
  if (diff < 0 || seconds < 60) return 'just now';
  if (minutes < 60) return `${minutes}m`;
  if (hours < 24) return `${hours}h`;
  if (days < 7) return `${days}d`;
  if (weeks < 52) return `${weeks}w`;
  return `${years}y`;
};

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  padding: 6px 0;
`;

const Label = styled.span`
  font-size: 14px;
  color: #222;
`;

const Time = styled.span`
  font-size: 13px;
  color: #b0b0b0;
  margin-left: 6px;
`;

const CashAmount = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.negative ? '#C34A26' : '#A6C857'};
  white-space: nowrap;
`;

const CreditAmount = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #6A7BFF;
  white-space: nowrap;
`;

export const CashPayoutSummaryLine = ({ amount, currency, dateCreated, now }) => {
  const { translate, locale } = useTokenTranslate();
  const isArabic = locale.startsWith('ar');
  const isNegative = amount < 0;
  return (
    <Row>
      <div>
        <Label>{translate('web.wallet_history_row.my_balance_text')}</Label>
        <Time>{getTimeDifference(dateCreated, now, isArabic)}</Time>
      </div>
      <CashAmount negative={isNegative}>
        {!isNegative ? '+' : ''}{formatPrice({ amount, currency })}
      </CashAmount>
    </Row>
  );
};

export const CreditSummaryLine = ({ credit, now }) => {
  const { translate, locale } = useTokenTranslate();
  const isArabic = locale.startsWith('ar');
  if (!credit || credit.actual_reward.amount === 0) return null;
  const name = credit.name || translate('web.wallet_history_row.store_credits_fallback');
  const displayName = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  return (
    <Row>
      <div>
        <Label>{displayName}</Label>
        <Time>{getTimeDifference(credit.date_created, now, isArabic)}</Time>
      </div>
      <CreditAmount>
        {formatPrice({ amount: credit.actual_reward.amount, currency: credit.actual_reward.currency })}
      </CreditAmount>
    </Row>
  );
};
